import { CheckCircle as CheckCircleIcon, Error as ErrorIcon } from '@mxenabled/mx-icons'

import { IconBacking } from '../../common'

type IconProp = {
  size?: number
}

const iconStyle = {
  gridRow: 1,
  gridColumn: 1,
  zIndex: 2,
}

export const ConnectedStatus = ({ size = 20 }: IconProp) => (
  <IconBacking size={size}>
    <CheckCircleIcon color="success" filled={true} sx={{ fontSize: size, ...iconStyle }} />
  </IconBacking>
)

export const ErrorStatus = ({ size = 20 }: IconProp) => (
  <IconBacking size={size}>
    <ErrorIcon color="error" filled={true} sx={{ fontSize: size, ...iconStyle }} />
  </IconBacking>
)
